import { lazy } from 'react';
import { type RouteObject } from 'react-router-dom';

import { ROUTES } from './routes/index';
import AllRoutesError from './wrappers/all-routes-wrapper/all-routes-error';

const AllRoutesWrapper = lazy(
  () => import('./wrappers/all-routes-wrapper/all-routes-wrapper'),
);

const ALL_ROUTES: RouteObject[] = [
  {
    element: <AllRoutesWrapper />,
    errorElement: <AllRoutesError />,
    children: ROUTES,
  },
];

export { ALL_ROUTES };
